module.exports = __webpack_public_path__ + "img/product-desc2.63539b86.png";